<template>
    <div v-if="submitting"
         class="fixed-content-width">
        <loading-container  />
    </div>
    <div v-else
         class="page-container">
        <vue-title :title="title" :brand="true"></vue-title>

        <div class="list-page-full">
            <div class="list-page-header">
                <div class="search-container">
                    <!--<div class="search-box">
                        <span class="icomoon">
                            
                        </span>
                        <input placeholder="Search" 
                            v-debounce:150="updateSearchTerm"   
                            type="text"/>
                    </div>      -->          

                    <div class="button-group">
                        <button @click="build">
                            <span>
                                Refresh
                            </span>
                        </button>
                        
                    </div>
                    <div class="button-group">
                        <span>
                            As Of: {{$filters.moment(lastRefreshTime, "L h:mm:ss a")}}
                        </span>

                    </div>
                </div>
            </div>

            <div class="list-page-contents">
                <table class="registration-table">
                    <thead>
                        <tr>
                            <th>
                                Session Date/Time
                            </th>
                            <th>
                                Session Name
                            </th>
                            <th>
                                Session Code
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="scan in scans">
                            <td>
                                {{ $filters.moment(scan.SessionDateTime, "L LT") }}<br>
                                <small>{{scan.SessionDurationMinutes}} minute(s)</small>
                            </td>
                            <td>
                                {{scan.SessionName}}
                            </td>
                            <td>
                                {{scan.SessionCode}}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style="text-align:center; margin-top: 1em; margin-bottom: 1em">
                    Note: this list is your unofficial attendance record. If there are any errors, please contact show support.
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Token from './authentication/token'
import Common from './common'
import QrCreator from 'qr-creator';
import { nextTick } from 'vue';
import { AppState } from './appstate';

export default {
    mixins: [
        Token, Common
    ],

    props: ['sectionCode'],

    computed: {
        title() {
            return AppState.show.Sections[this.sectionCode].Title;
        },
    },

    data() {
        return {
            notAuthenticated: false,
            scans: [],
            lastRefreshTime: new Date(),
        }
    },

    methods: {
        async build() {
            this.submitting = true;

            try {
                console.log("Attempting refresh...")
                let result = await this.tryGet(`/api/checkscans/${AppState.show.Code}/sessions/me`);
                this.scans = result.Result;
                this.lastRefreshTime = new Date();
            } catch {
                this.notAuthenticated = true;
            }

            this.submitting = false;
        },
    },

    mounted() {
        this.build();
    }
}
</script>